import React from 'react';
import { useNavigate } from 'react-router-dom';
import { colors } from '../styles';
import ActionButtons from './ActionButtons';

const styles = {
  card: {
    backgroundColor: colors.surface,
    border: `1px solid ${colors.border}`,
    borderRadius: '12px',
    padding: '1rem',
    marginBottom: '0.75rem',
    cursor: 'pointer',
    transition: 'border-color 0.2s, box-shadow 0.2s',
  },
  cardHover: {
    borderColor: colors.accent,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
  },
  header: {
    marginBottom: '0.5rem',
  },
  nombreRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '0.5rem',
  },
  nombre: {
    fontSize: '1rem',
    fontWeight: 600,
    color: colors.textPrimary,
    margin: 0,
    marginBottom: '0.25rem',
    flex: 1,
  },
  sourceBadge: {
    fontSize: '0.65rem',
    padding: '0.125rem 0.375rem',
    borderRadius: '4px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
  },
  sourceGoogle: {
    backgroundColor: '#e8f0fe',
    color: '#1967d2',
  },
  sourceVerified: {
    backgroundColor: colors.successBg || '#d1fae5',
    color: colors.success || '#059669',
  },
  meta: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    fontSize: '0.8rem',
    color: colors.textSecondary,
    flexWrap: 'wrap',
  },
  rating: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.25rem',
  },
  star: {
    color: '#fbbf24',
  },
  dot: {
    color: colors.textMuted,
  },
  zonas: {
    fontSize: '0.8rem',
    color: colors.textSecondary,
    marginTop: '0.25rem',
  },
  descripcion: {
    fontSize: '0.8rem',
    color: colors.textMuted,
    marginTop: '0.25rem',
    fontStyle: 'italic',
  },
  actions: {
    marginTop: '0.75rem',
    paddingTop: '0.75rem',
    borderTop: `1px solid ${colors.border}`,
  },
};

export default function ProviderCard({ proveedor, showActions = true, perfilId }) {
  const navigate = useNavigate();
  const [hovered, setHovered] = React.useState(false);

  const handleClick = (e) => {
    // No navegar si se hizo click en los botones de acción
    if (e.target.closest('button')) return;

    const params = new URLSearchParams();
    if (perfilId) params.set('perfil', perfilId);
    const query = params.toString() ? `?${params.toString()}` : '';
    navigate(`/localizador/lugar/${proveedor.id}${query}`);
  };

  return (
    <div
      style={{
        ...styles.card,
        ...(hovered ? styles.cardHover : {}),
      }}
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div style={styles.header}>
        <div style={styles.nombreRow}>
          <h3 style={styles.nombre}>{proveedor.nombre}</h3>
          {proveedor.source === 'google_cache' ? (
            <span style={{ ...styles.sourceBadge, ...styles.sourceGoogle }}>
              Google Maps
            </span>
          ) : proveedor.source !== 'user_suggestion' && (
            <span style={{ ...styles.sourceBadge, ...styles.sourceVerified }}>
              Verificado
            </span>
          )}
        </div>
        <div style={styles.meta}>
          {proveedor.rating && (
            <span style={styles.rating}>
              <span style={styles.star}>★</span>
              <span>{proveedor.rating}</span>
            </span>
          )}
          {proveedor.zonas && (
            <>
              <span style={styles.dot}>·</span>
              <span>Zona: {proveedor.zonas}</span>
            </>
          )}
        </div>
        {proveedor.descripcion && (
          <p style={styles.descripcion}>{proveedor.descripcion}</p>
        )}
      </div>

      {showActions && (proveedor.telefono || proveedor.whatsapp) && (
        <div style={styles.actions}>
          <ActionButtons
            telefono={proveedor.telefono}
            whatsapp={proveedor.whatsapp}
          />
        </div>
      )}
    </div>
  );
}
